<div class="transport-banner-container">
    <ng-container *ngFor="let leg of legs; let last = last">
        <ng-container [ngSwitch]="leg.mode">
            <ng-container *ngSwitchCase="busId">
                <mat-icon  [svgIcon]="busId | lowercase"></mat-icon>
                <span [style.text-decoration-color]="'#' + leg.routeColor" class="leg-name">{{leg.routeShortName}}</span>
            </ng-container>
            <mat-icon *ngSwitchCase="walkId" [svgIcon]="walkId | lowercase"></mat-icon>
            <mat-icon *ngSwitchCase="bicycleId" [svgIcon]="bicycleId | lowercase"></mat-icon>
            <mat-icon *ngSwitchCase="allId" [svgIcon]="allId | lowercase"></mat-icon>
        </ng-container>
        <mat-icon *ngIf="!last" class="arrow-next-icon">arrow_forward_ios</mat-icon>
    </ng-container>
    

</div>
